export default __webpack_public_path__ + "jewelfish_camera.d6116afa.png";